import * as React from 'react';
import useOnClickOutside from 'use-onclickoutside';
import { useIntl } from '@grandvisionhq/state';
import { FacetId } from '../../../types.js';
import CurrentRefinements from '../CurrentRefinements/CurrentRefinements.js';
import ConnectedFacetInputList from '../FacetInputList/ConnectedFacetInputList.js';
import ConnectedFacetInputPriceRange from '../FacetInputPriceRange/ConnectedFacetInputPriceRange.js';

const FacetsDesktop = ({ facets  })=>{
    const [activeFacet1, setActiveFacet] = React.useState();
    const handleToggle = React.useCallback((attribute)=>setActiveFacet(activeFacet1 === attribute ? undefined : attribute)
    , [
        activeFacet1
    ]);
    const ref = React.useRef(null);
    useOnClickOutside(ref, ()=>setActiveFacet(undefined)
    );
    const { getLabel  } = useIntl();
    const handleKeyDown = (event)=>{
        if (event.key === 'Escape') {
            event.stopPropagation() // stop event propagation to parent components
            ;
            // [A11y] land focus on the last active facet
            const activeFacet = document.getElementById('activeFacet');
            activeFacet === null || activeFacet === void 0 ? void 0 : activeFacet.focus();
            setActiveFacet(undefined) // close the drop down
            ;
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "facets-desktop"
    }, /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: "facets-desktop__top-bar",
        role: "toolbar",
        tabIndex: 0,
        onKeyDown: handleKeyDown,
        "aria-labelledby": "filters",
        "data-t": "facets-desktop-list"
    }, /*#__PURE__*/ React.createElement("h2", {
        id: "filters",
        className: "sr-only"
    }, getLabel('products.filters')), facets.map((facet)=>renderFacet(facet)
    )), /*#__PURE__*/ React.createElement("div", {
        className: "facets-desktop__refinements"
    }, /*#__PURE__*/ React.createElement(CurrentRefinements, null)));
    function renderFacet(facet) {
        if (facet.id === FacetId.price) return /*#__PURE__*/ React.createElement(ConnectedFacetInputPriceRange, {
            key: facet.attribute,
            facet: facet,
            attribute: facet.attribute,
            isActive: facet.attribute === activeFacet1,
            onToggle: handleToggle
        });
        return /*#__PURE__*/ React.createElement(ConnectedFacetInputList, {
            key: facet.attribute,
            facet: facet,
            attribute: facet.attribute,
            isActive: facet.attribute === activeFacet1,
            onToggle: handleToggle,
            searchable: facet.searchable,
            limit: 100
        });
    }
};

export { FacetsDesktop as default };
//# sourceMappingURL=FacetsDesktop.js.map
